import React, { Component } from 'react'
import styles from '../../styles/common/stepsList.module.css'

export class StepsListHeader extends Component {
    render() {
        const { listHeaderOpen, listHeader, title } = styles;
        const { isOpen, toggleStepsList, headStep, featureId } = this.props;
        return (
            <div className={isOpen ? listHeaderOpen : listHeader} onClick={() => toggleStepsList(featureId)}>
                <span className={title}>{headStep.title}</span>
                <i className={"material-icons"}>{isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
            </div>
        )
    }
}

export default StepsListHeader
